import { LinkButton } from '@cian/ui-kit';
import * as styles from './ValidatorButton.css';

interface IValidatorButtonProps {
  href: string;
  text: string;
}

export const ValidatorButton: React.FC<IValidatorButtonProps> = props => (
  <div className={styles['container']}>
    <LinkButton href={props.href} size="XS" theme="fill_secondary" target="_blank" rel="noopener noreferrer">
      {props.text}
    </LinkButton>
  </div>
);
